import { Auth } from 'aws-amplify'
import { consoleError } from 'shared/helpers/consoleError'
import { useLoadingStore } from 'shared/store/toasterSlice'

export const resetAllCaches = async () => {
  const { startLoading, finishWithSuccess, finishWithError } = useLoadingStore.getState()
  try {
    startLoading()
    const currentSession = await Auth.currentSession()
    let accessToken = currentSession.getIdToken()
    let jwt = accessToken.getJwtToken()
    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/reset_all_caches`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: jwt
      }
    })
    const data = await response.json()
    console.log(data)
    finishWithSuccess()
  } catch (error) {
    consoleError(error)
    finishWithError()
  }
}
